import React from 'react';
import { useIntl } from 'react-intl';
import { Typography, Card, CardContent, Box } from '@mui/material';

import PostIndicators from '../../../../Shared/PostIndicators';
import { isVoteStepOngoing } from '../../../../../../Utils/Steps';
import InteractionsBox from '../../../../Shared/InteractionsBox';
import { getPostSideHeaderText } from '../../../../PostSidePrimaryActions/utils';
import UserVotesInfo from '../../../../Shared/UserVotesInfo/UserVotesInfo';
import { SteppablePostType } from '../../../../../../Utils/Types/Steps';

function PostSidePrimaryActions({ post, space }: any) {
  const intl = useIntl();
  const postType = post?.type as SteppablePostType;

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" component="h2">
          {getPostSideHeaderText(post, intl)}
        </Typography>

        {isVoteStepOngoing(post?.included?.steps, postType) && (
          <Box sx={{ my: 2 }}>
            <UserVotesInfo post={post} space={space} />
          </Box>
        )}

        <Box sx={{ my: 2 }}>
          <InteractionsBox
            post={post}
            space={space}
            ctaVariant="contained"
            direction="column"
            onlyPrimaryActions
          />
        </Box>

        <PostIndicators postContributionsStats={post.post_contributions_stats} />
      </CardContent>
    </Card>
  );
}

export default PostSidePrimaryActions;
